module.exports = __webpack_public_path__ + "static/media/user-guide-btn.a73b7fc6.png";